export default __webpack_public_path__ + "static/media/wait.5509523b.svg";